import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import NumericInput from 'react-numeric-input';
import RichText from '../controls/RichText';
import { useForceUpdate, numberToLetter } from '../util';
import { Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { FormValidityReporter } from '../FormValidity';
import { getRawText } from '../util';
import "../App.css";
export function contentIsEmpty(content) {
  content = getRawText(content);
  if (content.length === 0) {
    return true;
  } else {
    return false;
  }
}
export default function TaskMultiChoice(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  if (dataProps.maxAttempts === -1) {
    dataProps.maxAttempts = Infinity;
  }
  const [radioValue, setRadioValue] = useState(dataProps.maxAttempts === Infinity || dataProps.maxAttempts === undefined ? 'attempts-0' : 'attempts-1');
  const radios = [{
    name: 'Infinite',
    value: 'attempts-0'
  }, {
    name: 'Numbered',
    value: 'attempts-1'
  }];
  const justifyRadios = [{
    name: 'Left',
    value: 'justify-0'
  }, {
    name: 'Center',
    value: 'justify-1'
  }];
  const [justifyRadioValue, setJustifyRadioValue] = useState(dataProps.justifyChoices === 'left' ? 'justify-0' : 'justify-1');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Prompt:"), " ", /*#__PURE__*/React.createElement("i", null, "Restate the question.")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.prompt,
    onChange: v => {
      dataProps.prompt = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.prompt)
  }, "Question Prompt is empty.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Maximum Number of Attempts:")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Row, null, radios.map((radio, idx) => {
    return /*#__PURE__*/React.createElement(Col, {
      xs: 3
    }, /*#__PURE__*/React.createElement(Form.Check, {
      inline: true,
      name: "attempts",
      label: radio.name,
      id: `attempts-${idx}`,
      checked: `attempts-${idx}` === radioValue,
      type: "radio",
      style: {
        margin: "10px 0px",
        width: "18px",
        height: "18px"
      },
      onChange: e => {
        dataProps.maxAttempts = Infinity;
        setRadioValue(e.target.id);
        forceUpdate();
        props.onChanged();
      }
    }));
  }), /*#__PURE__*/React.createElement(Col, null, radioValue === "attempts-1" && /*#__PURE__*/React.createElement(NumericInput, {
    min: 1,
    style: {
      padding: "5px 0px"
    },
    value: dataProps.maxAttempts === Infinity ? 1 : dataProps.maxAttempts,
    disabled: dataProps.maxAttempts === undefined,
    onChange: e => {
      if (e) {
        dataProps.maxAttempts = e;
      } else {
        dataProps.maxAttempts = 1;
      }
      forceUpdate();
      props.onChanged();
    }
  }))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Columns:"), " ", /*#__PURE__*/React.createElement("i", null, "Alignment only available for multiple columns.")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 1,
    max: 3,
    style: {
      padding: "5px 0px"
    },
    "aria-label": "Enter the number of columns in the multichoice, with a max of 3 and min of 1",
    value: dataProps.cols || 1,
    onChange: e => {
      if (1 <= e && e <= 3) {
        dataProps.cols = e;
      } else if (e < 1) {
        dataProps.cols = 1;
      } else if (3 < e) {
        dataProps.cols = 3;
      }
      forceUpdate();
      props.onChanged();
    }
  }))), dataProps.cols > 1 && /*#__PURE__*/React.createElement(Row, null, justifyRadios.map((radio, idx) => {
    return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Check, {
      inline: true,
      name: "justify",
      label: "Align " + radio.name,
      id: `justify-${idx}`,
      checked: `justify-${idx}` === justifyRadioValue,
      type: "radio",
      style: {
        margin: "10px 0px",
        height: "18px"
      },
      onChange: e => {
        dataProps.justifyChoices = radio.name.toLowerCase();
        setJustifyRadioValue(e.target.id);
        forceUpdate();
        props.onChanged();
      }
    }));
  })))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 1
  }, /*#__PURE__*/React.createElement(Form.Check, {
    name: "select-check",
    type: "checkbox",
    checked: dataProps.randomize,
    onChange: e => {
      dataProps.randomize = e.target.checked;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Shuffle:"), " ", /*#__PURE__*/React.createElement("i", null, "Responses will be shuffled."))))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Response Details"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Responses:"), " ", /*#__PURE__*/React.createElement("i", null, "Select the correct option.")), dataProps.choices.map((choice, key) => {
    return /*#__PURE__*/React.createElement(Form.Check, {
      id: "choice-" + key,
      name: "choices",
      style: {
        marginBottom: "20px"
      }
    }, /*#__PURE__*/React.createElement(Form.Row, {
      className: "align-items-center mb-2"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 1,
      style: {
        marginBottom: "25px"
      }
    }, /*#__PURE__*/React.createElement(Form.Check.Input, {
      type: "radio",
      checked: dataProps.correct.includes(key),
      style: {
        width: "18px",
        height: "18px"
      },
      onChange: e => {
        if (e.target.checked) {
          dataProps.correct.splice(0, dataProps.correct.length, key);
        }
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Check.Label, null, numberToLetter(key), ":\xA0"), /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(RichText, {
      value: dataProps.choices[key],
      onChange: v => {
        dataProps.choices[key] = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: !contentIsEmpty(dataProps.choices[key])
    }, "Response is empty.")), /*#__PURE__*/React.createElement(Col, {
      xs: 1
    }, dataProps.choices.length > 2 && /*#__PURE__*/React.createElement(Button, {
      variant: "outline-danger",
      title: "Remove choice",
      onClick: () => {
        dataProps.choices.splice(key, 1);
        dataProps.feedback.splice(key, 1);
        forceUpdate();
        props.onChanged();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    })))));
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add new choice",
    onClick: () => {
      dataProps.choices.push(new Content("new choice"));
      dataProps.feedback.push(new Content("test feedback"));
      forceUpdate();
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "2",
    title: "3. Feedback Details"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Feedback:")), /*#__PURE__*/React.createElement(Form.Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, numberToLetter(dataProps.correct[0]), " -"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "primary",
    onClick: () => {
      let fullPath = props.path.slice();
      fullPath.push("props", "feedback", dataProps.correct[0]);
      props.scopeToItem(fullPath);
    }
  }, "Edit Feedback")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Feedback:")), dataProps.choices.map((choice, key) => {
    if (key === dataProps.correct[0]) return undefined;
    return /*#__PURE__*/React.createElement(Form.Row, {
      className: "align-items-center mb-2"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, numberToLetter(key), " -"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        let fullPath = props.path.slice();
        fullPath.push("props", "feedback", key);
        props.scopeToItem(fullPath);
      }
    }, "Edit Feedback")));
  })))));
}